import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Legacy URLs `/gallery/:sessionId` redirect into the main gallery shell with search state.
 */
export const Route = createFileRoute("/gallery_/$sessionId")({
  component: RedirectGallerySessionToSearch,
});

function RedirectGallerySessionToSearch() {
  const { sessionId } = Route.useParams();
  return <Navigate to="/gallery" search={{ sessionId }} replace />;
}
